class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  lockPage() {
    this.scrollPosition = window.scrollY;
    this.header = this.header || document.querySelector('.section-header');
    if (this.header) {
      this.header.style.setProperty('position', 'fixed', 'important');
      this.header.style.top = '0';
      this.header.style.left = '0';
      this.header.style.right = '0';
      this.header.style.width = '100%';
    }

    this.bodyLockStyles = {
      position: document.body.style.position,
      top: document.body.style.top,
      left: document.body.style.left,
      right: document.body.style.right,
      width: document.body.style.width,
      overflowY: document.documentElement.style.overflowY,
    };

    document.documentElement.style.overflowY = 'scroll';
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + this.scrollPosition + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = `${document.documentElement.clientWidth}px`;
  }

  unlockPage() {
    if (!this.bodyLockStyles) return;

    document.body.style.position = this.bodyLockStyles.position;
    document.body.style.top = this.bodyLockStyles.top;
    document.body.style.left = this.bodyLockStyles.left;
    document.body.style.right = this.bodyLockStyles.right;
    document.body.style.width = this.bodyLockStyles.width;
    document.documentElement.style.overflowY = this.bodyLockStyles.overflowY;

    if (this.header) {
      this.header.style.removeProperty('position');
      this.header.style.removeProperty('top');
      this.header.style.removeProperty('left');
      this.header.style.removeProperty('right');
      this.header.style.removeProperty('width');
    }

    const scrollPosition = Number.isFinite(this.scrollPosition) ? this.scrollPosition : 0;
    this.bodyLockStyles = null;
    this.scrollPosition = null;

    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => window.scrollTo(0, scrollPosition));
    });
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.lockPage();
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
    this.unlockPage();
  }
}

customElements.define('details-modal', DetailsModal);
